import {Cell} from './Cell';

export class Row {
  rowItem: number;
  cells: Array<Cell> | any[];
}
